import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  NumberInput,
  NumberInputField,
  Image,
  Stack,
  useToast
} from '@chakra-ui/react';
import { useForm } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { createItem, updateItem } from '../../../api/item';

const Newitemform = ({ isOpen, onClose, item = {}, subcategoryId }) => {
    console.log("ss")
  const { register, handleSubmit, watch, reset, formState: { errors } } = useForm({
    defaultValues: item
  });
  const toast = useToast();
  const queryClient = useQueryClient();

  const [coverPhoto, setCoverPhoto] = useState(null);
  const [thumbnailPhotos, setThumbnailPhotos] = useState([]);
  const [files, setFiles] = useState(null);

  const mutation = useMutation(item._id ? updateItem : createItem, {
    onSuccess: () => {
      queryClient.invalidateQueries('items');
      toast({
        title: item._id ? 'Item updated.' : 'Item added.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      onClose();
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: error.message,
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  });

  useEffect(() => {
    if (item._id) {
      reset(item);
      setCoverPhoto(item.coverphoto);
      setThumbnailPhotos(item.thubnailphoto);
      setFiles(item.files);
    }
  }, [item, reset]);

  const onSubmit = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if (key === 'coverphoto' && coverPhoto) {
        formData.append(key, coverPhoto[0]);
      } else if (key === 'thubnailphoto' && thumbnailPhotos.length > 0) {
        thumbnailPhotos.forEach((photo, index) => {
          formData.append(`${key}[${index}]`, photo);
        });
      } else if (key === 'files' && files) {
        formData.append(key, files[0]);
      } else {
        formData.append(key, data[key]);
      }
    });
    formData.append('subcategoryId', subcategoryId);
    mutation.mutate(formData);
  };

  const handleFileChange = (e, setFieldValue) => {
    setFieldValue(e.target.files);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{item._id ? 'Update Item' : 'Add Item'}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <form id="item-form" onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={4}>
              <FormControl isInvalid={errors.name}>
                <FormLabel htmlFor="name">Name</FormLabel>
                <Input id="name" placeholder="Name" {...register('name', { required: 'Name is required' })} />
              </FormControl>
              <FormControl isInvalid={errors.description}>
                <FormLabel htmlFor="description">Description</FormLabel>
                <Textarea id="description" placeholder="Description" {...register('description', { required: 'Description is required' })} />
              </FormControl>
              <FormControl isInvalid={errors.startPrice}>
                <FormLabel htmlFor="startPrice">Start Price</FormLabel>
                <NumberInput>
                  <NumberInputField id="startPrice" placeholder="Start Price" {...register('startPrice', { required: 'Start Price is required', valueAsNumber: true })} />
                </NumberInput>
              </FormControl>
              <FormControl isInvalid={errors.minBidIncrement}>
                <FormLabel htmlFor="minBidIncrement">Min Bid Increment</FormLabel>
                <NumberInput>
                  <NumberInputField id="minBidIncrement" placeholder="Min Bid Increment" {...register('minBidIncrement', { required: 'Min Bid Increment is required', valueAsNumber: true })} />
                </NumberInput>
              </FormControl>
              <FormControl isInvalid={errors.deposit}>
                <FormLabel htmlFor="deposit">Deposit</FormLabel>
                <NumberInput>
                  <NumberInputField id="deposit" placeholder="Deposit" {...register('deposit', { required: 'Deposit is required', valueAsNumber: true })} />
                </NumberInput>
              </FormControl>
              <FormControl isInvalid={errors.numberofitem}>
                <FormLabel htmlFor="numberofitem">Number of Items</FormLabel>
                <NumberInput>
                  <NumberInputField id="numberofitem" placeholder="Number of Items" {...register('numberofitem', { required: 'Number of Items is required', valueAsNumber: true })} />
                </NumberInput>
              </FormControl>
              <FormControl isInvalid={errors.coverphoto}>
                <FormLabel htmlFor="coverphoto">Cover Photo</FormLabel>
                <Input type="file" id="coverphoto" onChange={(e) => handleFileChange(e, setCoverPhoto)} />
                {coverPhoto && <Image src={URL.createObjectURL(coverPhoto[0])} alt="Cover Photo" />}
              </FormControl>
              <FormControl isInvalid={errors.thubnailphoto}>
                <FormLabel htmlFor="thubnailphoto">Thumbnail Photos</FormLabel>
                <Input type="file" id="thubnailphoto" multiple onChange={(e) => handleFileChange(e, setThumbnailPhotos)} />
                {thumbnailPhotos && Array.from(thumbnailPhotos).map((photo, index) => (
                  <Image key={index} src={URL.createObjectURL(photo)} alt={`Thumbnail ${index + 1}`} />
                ))}
              </FormControl>
              <FormControl isInvalid={errors.files}>
                <FormLabel htmlFor="files">Files</FormLabel>
                <Input type="file" id="files" onChange={(e) => handleFileChange(e, setFiles)} />
                {files && <Image src={URL.createObjectURL(files[0])} alt="Files" />}
              </FormControl>
              <FormControl isInvalid={errors.startDate}>
                <FormLabel htmlFor="startDate">Start Date</FormLabel>
                <Input type="datetime-local" id="startDate" {...register('startDate', {
                  required: 'Start Date is required',
                  validate: (value) => new Date(value) > new Date() || 'Start Date cannot be in the past'
                })} />
              </FormControl>
              <FormControl isInvalid={errors.endDate}>
                <FormLabel htmlFor="endDate">End Date</FormLabel>
                <Input type="datetime-local" id="endDate" {...register('endDate', {
                  required: 'End Date is required',
                  validate: (value) => new Date(value) > new Date(watch('startDate')) || 'End Date must be after Start Date'
                })} />
              </FormControl>
            </Stack>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" type="submit" form="item-form" isLoading={mutation.isLoading}>
            {item._id ? 'Update Item' : 'Add Item'}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default Newitemform;
